import React, {Component} from 'react';
import {Modal, Row}  from 'react-bootstrap'
import FormFactory from '../../FormData/FormFactory';
import ModalFactory from '../../FormData/ModalFactory'
import { isplausibleEmail } from '../../Edit/validators';
import SecondServer from '../../database/SecondServer'
import {urlGetSite} from '../../database/apiUrls'

import '../report-header.css'
import '../Controls/massedit.css'
import '../../commoninputs.css'
import { siteAccessCode } from '../../database/apiv2SiteAccessor';

export default class EmailModal extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      rerender: 0,
      validations: {"dlgEmail": true},
    }
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.ff = new FormFactory()
  }

  componentDidMount() {
    this.ff.init()
  }

  async handleClose() {
    this.props.hide();
    this.ff.init();
  }

  handleChange = event => {
    this.ff.handleChange(event);
    this.setState ({rerender: this.state.rerender+1})
  }

  valid(fieldName, how) {
    const field = this.ff.findChange (fieldName)
    const what = how(field?.value)
    let all = this.state.validations
    all[fieldName] = what;
    this.setState({validations: all})
    return what
  }
  validate () {
    const list = [
      {name: 'dlgEmail', method:(value)=>isplausibleEmail(value??''), msg: "Email is not correct"},
    ]
    let localValids = []
    list.forEach(item => localValids.push(this.valid(item.name, item.method)))
    const badIndex = localValids.indexOf(false)
    return badIndex === -1 ? null : list[badIndex].msg
  }
  
  async moveOn (msg) {
    this.handleClose();

    if (this.props.onChange)
      this.props.onChange(this.state);
  }
  
   async handleSave() {
    const errs = this.validate()
    if (errs) 
      return errs
    let apiData = this.props.siteInfo?.all_alert_targets ?? []
    apiData.push(this.ff.findChange('dlgEmail')?.value ?? '')
    const ss = new SecondServer(this.props);
    const url = urlGetSite(siteAccessCode(this.props.getActiveSite()))
    const resp = await ss.apiSaveData(url, {"all_alert_targets" : apiData})
    if (this.props?.onChange) this.props.onChange()
    return resp?.response?.data?.data?.result?.message ?? ss.getErrorMsg()  
  }

  render() {
    const inputs = [
      {key: 'dlgEmail', label: 'Email', valid: this.state.validations.dlgEmail},
    ] 
    return(
      <ModalFactory show={this.props.show} header="Enter Email" inputs={inputs} 
       handleChange={this.handleChange}
       ff={this.ff} validate={this.validate} handleSave={this.handleSave} hide={this.handleClose}>
        <ModalBody />
      </ModalFactory>
    )
  }
}

function ModalBody(props) {
  const el = props.elements
  return(
    <Modal.Body className='body-indent'>
      <Row className='mt-5 modal-top-row '>
        {el[0]}
      </Row>
    </Modal.Body>
  )
}